import { components } from "@certn/api/generated-schemas/client-portal";
import { createContext } from "react";

import {
  OrderingCheckListChild,
  OrderingUmbrellaSelectOption,
} from "../../../components/ordering-check-card/types";
import { CheckData } from "../types";
import { SelectedCheckAddOn } from "../../order/OrderContext";

export interface SelectedChecksType {
  key: string;
  name: string;
  cost: number;
  currency: string;
  check_arguments: Record<string, unknown>;
  children?: OrderingCheckListChild[];
  required_check_types?: string[];
  must_be_ordered_with_one_of?: string[];
  checkDetails: CheckData;
  selectedOptions?: OrderingUmbrellaSelectOption[];
  add_on_options?: SelectedCheckAddOn[];
}

export interface SelectedBundlesType {
  id: string;
  title: string;
  products: components["schemas"]["AvailableBundleProductsListChild"][];
  currency: components["schemas"]["CurrencyEnum"];
  total: number;
  price?: string;
  check_types_with_arguments: Record<string, unknown>;
  checks?: {
    type: string;
    name: string;
    /** Format: double */
    price: number;
    currency: components["schemas"]["CurrencyEnum"];
    estimated_turnaround_time: string;
    disclaimers_icon_list: string[];
    disclaimers: string[];
    description: string;
    info_paragraphs: string[][];
    key_features: string[][];
    coverage: string;
    how_it_can_help_you: string[][];
    select_field_descriptions: string[][];
    select_field_endpoint: string;
    check_has_ordering_error_for_customer_group: string | null;
    mutually_exclusive_check_types: string[];
    umbrella_child_checks_heading: string | null;
    required_check_types: string[];
    must_be_ordered_with_one_of?: string[];
    select_options: components["schemas"]["BundledDealUmbrellaCheckSelectOption"][];
    children: components["schemas"]["BundledDealCheckListChild"][];
    check_arguments: string | Record<string, unknown>;
    add_on_options?: SelectedCheckAddOn[];
  }[];
}
export interface Package {
  name: string;
  description: string;
  tag_names: components["schemas"]["Tags"][];
  checks: SelectedChecksType[];
  bundles: SelectedBundlesType[];
  rubric_id: string | null;
  is_ats_package?: boolean;
  is_api_package?: boolean;
  is_applicant_pay?: boolean;
  client_input_claims?: Record<string, unknown>;
}

export interface PackageContextType {
  packageData: Package;
  currentStep: number;
  setPackage: (packageData: Package) => void;
  setClientInputClaims: (claims: Record<string, unknown>) => void;
  goToNextStep: () => void;
  goToPrevStep: () => void;
}

export const PackageContext = createContext<PackageContextType>({
  packageData: {
    name: "",
    description: "",
    tag_names: [],
    checks: [],
    bundles: [],
    rubric_id: null,
  },
  setPackage: (newState: Package) => newState,
  setClientInputClaims: () => undefined,
  currentStep: 0,
  goToNextStep: () => undefined,
  goToPrevStep: () => undefined,
});
